import React from "react";
import Button from "@mui/material/Button";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

export default function ({
  swipeStyle,
  arrowColor,
  direction = "left",
  opacity = 0.75,
  onClick,
  className,
}) {
  return (
    <Button
      variant="contained"
      sx={{
        maxWidth: 32,
        maxHeight: 32,
        minWidth: 32,
        minHeight: 32,
        borderRadius: "50%",
        opacity: opacity,
        backgroundColor: "#FFF",
        color: "text.primary",
        "&:hover": {
          backgroundColor: "#FFF",
          color: "text.primary",
          opacity: 1,
        },
        ...swipeStyle,
      }}
      onClick={onClick}
      className={className}
    >
      {direction == "left" ? (
        <KeyboardArrowLeftIcon
          sx={{
            color: arrowColor || "text.primary",
            minWidth: 7.41,
            minHeight: 12,
          }}
        />
      ) : (
        <KeyboardArrowRightIcon
          sx={{
            color: arrowColor || "text.primary",
            minWidth: 7.41,
            minHeight: 12,
          }}
        />
      )}
    </Button>
  );
}
